// import useMediaQuery from '@material-ui/core/useMediaQuery'
// import { useTheme } from '@material-ui/core/styles'
// const theme = useTheme()
// const isMdUp = useMediaQuery(theme.breakpoints.up('md'))
export const ContractsTableConstants = [
  { field: 'contrato', sorting: true, align: 'left', width: 120 },
  { field: 'direccion_suministro', sorting: true, align: 'left', width: 120},
]